
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/original",
      function () {
        return require("private-next-pages/original.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/original"])
      });
    }
  